export default "__VITE_ASSET__EDH0kMnN__"